import React, { useState } from "react";
import { PlanificationsService } from "~/services/planificationsService";
import { AuthService } from "~/services/authService";
import moment from "moment";

const MyCalendar = () => {
	const authService = new AuthService();
	const { user } = authService.useUserContext();
	const [dateSelected, setDateSelected] = useState(null);

	const planificationsService = new PlanificationsService();
	const {
		data: apiGetData,
		error: apiGetError,
		isLoading: apiGetIsLoading,
		callToAction: apiGetHandler,
	} = planificationsService.useGetAll("", "", user.id);

	if (apiGetIsLoading) return <div>Chargement ...</div>;

	const today = new Date();
	today.setHours(0, 0, 0, 0); // Ensure time is set to the start of the day

	const handleDateClick = (date) => {
		if (moment(dateSelected).isSame(date, "day")) {
			setDateSelected(null);
		} else {
			setDateSelected(date);
		}
	};

	return (
		<div className="w-full flex flex-col justify-center content-center">
			<h1 className="text-2xl">Mon planning</h1>
			<div className="p-5">
				{apiGetData &&
					apiGetData
						.filter((planification) => {
							const planificationDate = new Date(planification.date);
							planificationDate.setHours(0, 0, 0, 0);
							return planificationDate >= today;
						})
						.sort((a, b) => new Date(a.date) - new Date(b.date))
						.map((planification, i) => {
							const planificationDate = moment(planification.date);
							const isSelected = moment(dateSelected).isSame(
								planificationDate,
								"day",
							);
							return (
								<div key={i} className="flex-row">
									<div
										onClick={() => handleDateClick(planification.date)}
										className={`bg-slate-300 text-2xl p-2 cursor-pointer ${isSelected ? "bg-slate-400" : ""}`}
									>
										{planificationDate.format("DD/MM/YYYY")} :{" "}
										{planification.chantier.title &&
											planification.chantier.title}{" "}
									</div>
									{isSelected && (
										<div className="bg-slate-200 p-2 flex-row">
											<div className="">
												{planification.chantier.address &&
													planification.chantier.address}
												,{" "}
												{planification.chantier.postal_code &&
													planification.chantier.postal_code}{" "}
												{planification.chantier.city &&
													planification.chantier.city}{" "}
											</div>
											<div className="flex-row">
												<div className="">
													{planification.chantier.phone1 && (
														<>
															{planification.chantier.phone1}{" "}
															<a className="bg-white" href={`tel:${planification.chantier.phone1}`}>
																[📞 APPELER]
															</a>
														</>
													)}
												</div>
												<div className="">
													{planification.chantier.phone2 && (
														<>
															{planification.chantier.phone2}{" "}
															<a className="bg-white" href={`tel:${planification.chantier.phone2}`}>
																[📞 APPELER]
															</a>
														</>
													)}
												</div>
											</div>
										</div>
									)}
								</div>
							);
						})}
			</div>
		</div>
	);
};

export default MyCalendar;
